export default "__VITE_ASSET__DHthpQ11__"